import get from "lodash.get";
import isEmpty from "lodash.isempty";
import { useCallback, useEffect, useState } from "react";

import * as Client from "api/client";
import { lineOAUrl, stage } from "config/const";
import { useLiff } from "providers/Liff";
import { useToast } from "providers/Toast";
import { sendError } from "tracking";
import { isMobile } from "utils/method";
import Context from "./Context";

async function getClientProfiles(liff) {
  try {
    const profile = await liff.getProfile().catch((error) => {
      console.error(error);
      sendError(`[getClientProfiles.profile]: ${error.toString()}`);
      liff.logout();
      liff.login({ redirectUri: window.location.href });
      return false;
    });
    if (!profile) return { error: true };
    const userId = profile.userId;
    const accessToken = liff.getAccessToken();
    const client = await Client.getCreateCustomer(userId, accessToken);

    if (client.err) {
      sendError(`[getClientProfiles.getCreateCustomer]: ${client.message}`);
      return { error: client.message };
    }

    return { client, profile, accessToken, userId };
  } catch (error) {
    sendError(`[getClientProfiles.catch]: ${error.toString()}`);
    return { error };
  }
}

let refreshingClient = false;
const Provider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [client, setClient] = useState({});
  const [profile, setProfile] = useState({});
  const { liff, ready } = useLiff();
  const { danger } = useToast();

  const validAuth =
    auth.userId && auth.accessToken && !isEmpty(profile) && !isEmpty(client);
  const refreshToken = get(client, "idToken.refreshToken");

  const refreshClient = async () => {
    if (refreshingClient) return;
    refreshingClient = true;
    const { client, profile, accessToken, userId, error } =
      await getClientProfiles(liff);
    refreshingClient = false;
    if (isEmpty(client) || isEmpty(profile) || error) {
      danger("Please login again");
      return { err: true };
    }

    // sendTagToo(profile);

    setProfile(profile);
    setClient(client);
    setAuth({ id: client.id, accessToken, userId, idToken: client.idToken });
    return { err: false };
  };

  const updateClient = (data) => {
    return Client.updateCustomer(auth.userId, auth.idToken, data).then(
      (res) => {
        if (res.err) {
          danger("Fail");
        } else {
          refreshClient();
        }
      },
    );
  };

  const refresh = useCallback(async () => {
    if (!refreshToken) return;
    const newIdToken = await Client.refreshIdToken(refreshToken);
    if (newIdToken.err) {
      console.error(newIdToken.err);
      return;
    }
    setAuth({ ...auth, idToken: newIdToken });
  }, [refreshToken]);

  useEffect(() => {
    if (!liff || !ready) return;

    if (stage !== "local" && !isMobile())
      return window.location.replace(lineOAUrl);

    if (!liff.isLoggedIn()) {
      console.log(liff.isLoggedIn());
      return liff.login({ redirectUri: window.location.href });
    }

    refreshClient();
  }, [liff, ready]);

  const props = {
    auth,
    profile,
    client,
    validAuth,
    refresh,
    refreshClient,
    updateClient,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
